import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { Logo } from '@/components/Logo'

/**
 * The chrome the terms and privacy pages share.
 *
 * Both are reachable signed out — they are linked from the sign-in screen, and
 * Google's OAuth consent screen links to them from outside the app entirely —
 * so neither can sit inside `AppShell`, whose nav assumes a session. This is
 * the header they carry instead.
 */
export function LegalPage({
  title,
  updated,
  children,
}: {
  title: string
  /** When the wording last changed, written out in full. */
  updated: string
  children: ReactNode
}) {
  return (
    <div className="legal-page">
      <header className="legal-head">
        <Logo layout="lockup" theme="white" size={34} />
        <Link to="/sign-in">Back to sign in</Link>
      </header>

      <main className="legal-body">
        <h1 className="page-title">{title}</h1>
        <p className="legal-updated">Last updated {updated}</p>
        {children}
      </main>
    </div>
  )
}
